import { LoaderButton } from 'components/molecules'
import GoToBlogPostPage from 'domains/cms-blog-post/organisms/form/go-to-blog-post-page'
import CmsBlogPostFormSchema from 'domains/cms-blog-post/organisms/form/cms-blog-post-form-schema'
import BlogPostDetailFields from './blog-post-detail-fields'
import BlogPostSectionFields from './blog-post-section-fields'
import BlogPostMetadataFields from './blog-post-metadata-fields'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  blogPost: PropTypes.shape({
    title         : PropTypes.string,
    url           : PropTypes.string,
    active_status : PropTypes.string,
    summary       : PropTypes.string,
    hero_img_url  : PropTypes.string,
    category      : PropTypes.array,
    sections      : PropTypes.FieldArray,
    meta_data     : PropTypes.object
  }),
  buttonText          : PropTypes.string,
  heroImage           : PropTypes.object,
  sectionImages       : PropTypes.array,
  tempSectionImage    : PropTypes.object,
  isEditAction        : PropTypes.bool,
  setHeroImage        : PropTypes.func,
  setSectionImages    : PropTypes.func,
  setTempSectionImage : PropTypes.func,
  handleSubmitForm    : PropTypes.func.isRequired
}

const defaultProps = {
  blogPost: {
    title         : '',
    url           : '',
    active_status : '',
    summary       : '',
    hero_img_url  : '',
    category      : [],
    sections      : [],
    meta_data     : {
      title       : '',
      keyword     : '',
      description : ''
    },
    buttonText          : '',
    heroImage           : new Blob(),
    sectionImages       : [],
    tempSectionImage    : new Blob(),
    isEditAction        : false,
    setHeroImage        : () => {},
    setSectionImages    : () => {},
    setTempSectionImage : () => {},
    handleSubmitForm    : () => {}
  } }

const initialValues = (blogPost) => ( {
  title         : blogPost?.title || '',
  url           : blogPost?.url || '',
  active_status : blogPost?.active_status || '',
  summary       : blogPost?.summary || '',
  hero_img_url  : blogPost?.hero_img_url || '',
  category      : blogPost?.category || [],
  sections      : blogPost?.sections|| [ {
    id            : '',
    title         : '',
    image_url     : '',
    collection_id : '',
    description   : '',
    value         : ''
  } ],
  meta_data: {
    title       : blogPost?.meta_data.title || '',
    keyword     : blogPost?.meta_data.keyword || '',
    description : blogPost?.meta_data.description || ''
  }
} )

const sectionInitialValue = { title: '', description: '', collection_id: '', value: '' }

/**
 * Form to create and edit CMS Blog Post
 */

const CmsBlogPostForm = ({
  blogPost,
  isEditAction,
  buttonText,
  heroImage,
  sectionImages,
  tempSectionImage,
  setHeroImage,
  setSectionImages,
  setTempSectionImage,
  handleSubmitForm
}) =>  (
  <Formik
    enableReinitialize={ true }
    initialValues={ initialValues(blogPost) }
    validationSchema={ CmsBlogPostFormSchema }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <Form>
          <GoToBlogPostPage url= { formikBag.values.url } />
          <BlogPostDetailFields
            formikBag= { formikBag }
            heroImage= { heroImage }
            setHeroImage= { setHeroImage }
            isEditAction= { isEditAction }
          />

          <BlogPostSectionFields
            formikBag= { formikBag }
            sectionImages= { sectionImages }
            setSectionImages= { setSectionImages }
            tempSectionImage= { tempSectionImage }
            setTempSectionImage= { setTempSectionImage }
            sectionInitialValue= { sectionInitialValue }
          />

          <BlogPostMetadataFields />

          <LoaderButton
            className='float-right'
            color='success'
            isLoading={ formikBag.isSubmitting }
            onClick={ formikBag.submitForm }
            text={ buttonText }
          />
        </Form>
      )
    }
  </Formik>
)


CmsBlogPostForm.propTypes    = propTypes
CmsBlogPostForm.defaultProps = defaultProps

export default CmsBlogPostForm
